import { Component } from '@angular/core';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    standalone: false
})
export class InvoiceComponent {
     companyType: string = '';
     constructor(public generalService: GeneralService, private authenticationService: AuthenticationService) {
          const userProfile = this.authenticationService.getUserProfile() as UserProfile;
          const customer = userProfile!.customer;
          this.companyType = customer.customerType === 1 ?
               'MC' :
               customer.customerType === 6 ?
                    'ISP' :
                    '';
     }

     ngOnInit() {
          setTimeout(() => this.scrollToTop(), 500);
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
